module.exports = __webpack_public_path__ + "img/ba0020e.png";